import { EButtonEvents } from '@Managers/Events/ButtonEvents';
import EventsCenter from '@Managers/Events/EventsCenter';
import { Checkbox } from '@UILayer/Inputs/Checkbox';
import { DOM_ID } from '@UILayer/UILayer.types';
import React, { useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';

// REDUX
import { getMuteButtonActive, getUnmuteButtonActive } from '@Managers/Redux/AppState/AppState';
import { useAppDispatch, useAppSelector } from '@Managers/Redux/Hooks';

// CSS
import styles from '@UILayer/UILayer.scss';

// IMAGES
import soundOff from '@Images/sound_off.png';
import soundOn from '@Images/sound_on.png';

//PANELS & VIEWS

const PreloaderSoundCheckbox: React.FC<{}> = ({}) => {
    const [state, setState] = useReducer(
        (state: { isMuteButtonActive: boolean; isUnmuteButtonActive: boolean }, newState: any) => ({ ...state, ...newState }),
        { isMuteButtonActive: false, isUnmuteButtonActive: false }
    );
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const gameStoreMuteButtonActive = useAppSelector(getMuteButtonActive);
    const gameStoreUnmuteButtonActive = useAppSelector(getUnmuteButtonActive);

    useEffect(() => {
        setState({
            isMuteButtonActive: gameStoreMuteButtonActive,
            isUnmuteButtonActive: gameStoreUnmuteButtonActive
        });
    }, [gameStoreMuteButtonActive, gameStoreUnmuteButtonActive]);

    function action() {
        if (state.isMuteButtonActive) EventsCenter.emit(EButtonEvents.MUTE_BUTTON_PRESSED);
        if (state.isUnmuteButtonActive) EventsCenter.emit(EButtonEvents.UNMUTE_BUTTON_PRESSED);
    }

    return (
        <>
            <div className={styles.prealoder_checkbox}>
                <img className={styles.prealoder_checkbox_icon} src={state.isMuteButtonActive ? soundOn : soundOff} alt="Sound icon" />
                <Checkbox
                    id={DOM_ID.CHECKBOX_SOUND_PRERLOADER}
                    checked={state.isMuteButtonActive}
                    ariaLabel={t('WCA_TOGGLE_SOUND_BUTTON')}
                    onChange={action}
                    showLabel={false}
                />
            </div>
        </>
    );
};

export default PreloaderSoundCheckbox;
